import { declMod } from '@yandex-lego/i-bem-react';
export default declMod({
  provider: 'yandex-team'
}, {
  block: 'user-pic',
  getAvatarURL: function getAvatarURL() {
    var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://center.yandex-team.ru';
    var avatarId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    return {
      lodpiUrl: "".concat(host, "/api/v1/user/").concat(avatarId, "/avatar/42.jpg"),
      hidpiUrl: "".concat(host, "/api/v1/user/").concat(avatarId, "/avatar/100.jpg")
    };
  }
});